

















































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import StornoSummaryInvoice from "../models/StornoSummaryModel";
import ApiSearch, { ApiSearchColumn } from "@/components/apiSearch/models/ApiSearch";
import dayjs from "dayjs";
import { store } from "../services/StornoSummaryStore";
import eventBus from "@/services/eventBus";
import { dateFormatHU } from "@/filters/date-format";
import moneyFormat from "@/filters/money-format";
import DateInput from "@/components/DateInput.vue";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  components: {
    ApiSearchPage,
    DateInput
  },

  data() {
    return {
      store,
      selectedInvoices: [] as any[],
    };
  },

  methods: {
    refreshApiSearch() {
      const childComponentInstance = this.$refs.asref;
      if (childComponentInstance) {
        (this.$refs.asref as any).refreshClick();
      }
    },

    selectChangeHandler(item: any) {
      item.selected = !item.selected;
      const selectedInv = item;
      if (item.selected) this.selectedInvoices.push(selectedInv);
      if (!item.selected)
        this.selectedInvoices = this.selectedInvoices.filter((i) => !(item.prefix == i.prefix && item.invId == i.invId));
    },

    async selectButtonClickHandler() {
      if (this.selectedInvoices.length === 0) {
        eventBus.$emit("error", t("StornoSummary_JeloljonKiLegalabbEgySzamlat"));
        return;
      }

      const ret = await this.store.StornoSummary(this.selectedInvoices);
      if (ret){
        eventBus.$emit("success", t("StornoSummary_SikeresSztorno"));
        this.refreshApiSearch();
      }
    },

    beforeRefreshHandler() {
      this.selectedInvoices = [];
    },
  },

  computed: {
    columns(): ApiSearchColumn[] {
      return [
        { cell: "selectTemplate", filterable: false },
        { field: "prefix", title: t("Prefix") },
        { field: "invId", title: t("BelsoAzonosito") },
        { field: "outerInvNo", title: t("KulsoSzamlaszam") },
        { field: "bgInvNo", title: t("Szamlaszam") },
        { field: "invDate", title: t("SzamlaDatuma"), cell: "invDateTemplate", headerClass: "wider-centered", fieldClass: "wider-centered"},
        { field: "outerInvNoSt", title: t("StornoSummary_JovairoKulsoSzamlaszam") },
        { field: "invoiceStId", title: t("StornoSummary_JovairoBelsoAzonosito") },
        { field: "invoiceStInvNo", title: t("StornoSummary_JovairoSzamlaszam") },
        { field: "stornoDate", title: t("StornoSummary_JovairasDatuma"), cell: "stornoDateTemplate" },
        { field: "shipDate", title: t("TeljesitesDatuma"), cell: "shipDateTemplate"},
        { field: "accDate", title: t("KonyvelesDatuma"), cell: "accDateTemplate"},
        { field: "partnerName", title: t("PartnerNeve") },
        { field: "currTotal", title: t("StornoSummary_BruttoSzamlaPenzneme"), cell: "currTotalTemplate" },
        { field: "currNetto", title: t("StornoSummary_NettoSzamlaPenzneme"), cell: "currNettoTemplate" },
        { field: "currVat", title: t("StornoSummary_AfaSzamlaPenzneme"), cell: "currVatTemplate"},
        { field: "invCurrency", title: t("SzamlaPenzneme") },
        { field: "stornoUserName", title: t("StornoSummary_JovairoFelhasznalo") },
        { field: "netto", title: t("Netto"), cell: "nettoTemplate"},
        { field: "vat", title: t("AFA"), cell: "vatTemplate"},
        { field: "total", title: t("Brutto"), cell: "totalTemplate"},
        { field: "currency", title: t("Penznem") },
      ];
    },
  },
});
